/** HubSpot portals already used by public/index.html. Do not add hosts. */
const HUBSPOT_PORTAL_BY_HOST = {
    'tempfilter.honestdiscounts.com': '8256145',
    'localhost:5464': '8256145',
    'staging.honestdiscounts.com': '8256145',
    'staging.glichealth.com': '8256145',
    'dev.glichealth.com': '8256145',
    'release.glichealth.com': '8256145',
    'reporting.honestdiscounts.com': '5268728',
    'reporting.glichelth.com': '5268728',
};

/** Same hosts that load rxhacker.css and the orange-black theme. */
export function isRxBrand() {
    if (typeof window === 'undefined') {
        return false;
    }
    const host = window.location.host.toLowerCase();
    const registrable = host.split('.').slice(-2).join('.');
    return registrable === 'rxhacker.com'
        || registrable === 'localhost:5464'
        || host === 'tempfilter-dev.glichealth.com'
        || host === 'reporting.nulifespanrx.com';
}

export function applyConsentBrand() {
    if (typeof document === 'undefined') {
        return;
    }
    document.documentElement.classList.add(isRxBrand() ? 'brand-rx' : 'brand-glic');
}

export function shouldShowCookieConsent() {
    return typeof window !== 'undefined';
}

/** Google Tag Manager is currently injected on every host. */
export function shouldLoadAnalyticsTags() {
    return shouldShowCookieConsent();
}

export function hubSpotPortalId() {
    if (typeof window === 'undefined') {
        return null;
    }
    return HUBSPOT_PORTAL_BY_HOST[window.location.host] || null;
}

export function shouldLoadHubSpot() {
    return !!hubSpotPortalId();
}
